import { useCallback } from 'react';

export default function Hero() {
  const scrollTo = useCallback((id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  }, []);

  return (
    <section
      id="hero"
      className="relative w-full min-h-[520px] md:min-h-[620px] pt-[72px] flex items-center overflow-hidden bg-gradient-to-b from-background-100 via-background-50 to-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl"></div>
        <div className="absolute -bottom-20 -left-20 w-[400px] h-[400px] rounded-full bg-accent-100/20 blur-3xl"></div>
      </div>

      <div className="relative w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/80 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line"></i>
              <span>每日更新 · 高清蓝光 · 免广告免费看</span>
            </p>

            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 font-heading leading-tight">
              天堂影视 · 电影大全免费在线观看
            </h1>

            <p className="mt-4 text-lg md:text-xl text-foreground-600 font-heading font-medium">
              高清蓝光画质，不缓冲不卡顿，畅享纯粹观影
            </p>

            <p className="mt-5 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[600px] mx-auto lg:mx-0">
              天堂影视汇聚海量电影资源，收录最新院线大片、高分经典电影和热门影视剧集。我们坚持每日更新片库，
              采用高速服务器确保高清蓝光画质流畅播放，全程免广告打扰，让每一位影迷都能享受纯净的在线观影体验。
              无论你偏爱动作大片、悬疑烧脑、温情文艺还是爆笑喜剧，天堂影视都能满足你的观影需求。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6">
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span>片库 <strong className="text-foreground-900">10 万+</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span>每日更新 <strong className="text-foreground-900">50+</strong>部</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-primary-500 text-base"></i>
                <span>全程 <strong className="text-foreground-900">免广告</strong>观影</span>
              </div>
            </div>

            <div className="mt-7 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => scrollTo('#ranking')}
                className="w-full sm:w-auto px-7 py-3 rounded-lg bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line mr-1.5"></i>
                热门电影榜单
              </button>
              <button
                onClick={() => scrollTo('#features')}
                className="w-full sm:w-auto px-7 py-3 rounded-lg bg-background-100 border border-background-300/60 text-foreground-800 font-medium text-sm hover:bg-background-200 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line mr-1.5"></i>
                了解平台优势
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden bg-background-100 aspect-[4/3] md:aspect-[5/4]">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20reel%20and%20movie%20projector%20in%20a%20warm%20golden%20lit%20vintage%20cinema%20setting%2C%20soft%20dramatic%20lighting%20with%20dust%20particles%20floating%20in%20the%20air%2C%20dark%20theater%20background%20with%20rich%20crimson%20curtains%2C%20classic%20movie%20posters%20subtly%20visible%2C%20warm%20amber%20and%20deep%20red%20tones%2C%20nostalgic%20and%20artistic%20cinematography%20style%2C%20high%20contrast%2C%20atmospheric%20and%20immersive%20composition&width=700&height=560&seq=hero-cinema-main&orientation=landscape"
                alt="天堂影视 - 电影在线观看平台主视觉"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                }}
              />
              <div className="absolute inset-0 bg-gradient-to-r from-black/10 to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}